import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import App from "App";

// Material Dashboard 2 React Context Provider
import { MaterialUIControllerProvider } from "context";

// Importez AuthProvider
import { AuthProvider } from "./context/AuthContext";

const container = document.getElementById("app");
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <HelmetProvider>
      <BrowserRouter>
        <MaterialUIControllerProvider>
          <AuthProvider>
            <App />
          </AuthProvider>
        </MaterialUIControllerProvider>
      </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode>
);
